module.exports = __webpack_public_path__ + "danger.f6dc099240cc766d0ba0.svg";


//////////////////
// WEBPACK FOOTER
// /Users/andrescufari/Angular/lednube/theme/images/icon/danger.svg
// module id = ../../../../../theme/images/icon/danger.svg
// module chunks = styles